window.PH = window.PH || {};

PH.searchEngine = {
  version: '0.3.5-knowledge',

  synonyms: {
    bacara: 'baccarat',
    bacarat: 'baccarat',
    br540: 'baccarat rouge 540',
    savage: 'sauvage',
    invictuz: 'invictus',
    ysl: 'yves saint laurent',
    tomford: 'tom ford'
  },

  normalize(text) {
    return String(text || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9\s]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  },

  expandQuery(query) {
    const clean = this.normalize(query);

    return this.normalize(
      clean
        .split(' ')
        .map(word => this.synonyms[word] || word)
        .join(' ')
    );
  },

  isPackageProduct(product) {
    const text = this.normalize([
      product.name,
      product.title,
      product.fullName,
      product.handle,
      product.tags,
      product.type
    ].join(' '));

    return text.includes('paquete') || text.includes('package');
  },

  hasStrongMatch(product, query) {
    const q = this.expandQuery(query);

    const fields = [
      product.name,
      product.title,
      product.fullName,
      product.vendor,
      product.brand,
      product.designer,
      product.tags,
      product.type,
      product.searchText,
      product.inspiredBy,
      product.family,
      product.gender,
      ...(product.moods || []),
      ...(product.occasions || []),
      ...(product.seasons || []),
      ...(product.notes || [])
    ].map(field => this.normalize(field));

    if (fields.some(field => field.includes(q))) return true;

    const words = q.split(' ').filter(word => word.length >= 3);

    return words.every(word =>
      fields.some(field => field.includes(word))
    );
  },

  score(product, query) {
    const q = this.expandQuery(query);

    let score = 0;

    const name = this.normalize(product.name);
    const title = this.normalize(product.title);
    const fullName = this.normalize(product.fullName);
    const vendor = this.normalize(product.vendor);
    const brand = this.normalize(product.brand);
    const designer = this.normalize(product.designer);
    const tags = this.normalize(product.tags);
    const type = this.normalize(product.type);
    const searchText = this.normalize(product.searchText);
    const inspiredBy = this.normalize(product.inspiredBy);
    const family = this.normalize(product.family);
    const gender = this.normalize(product.gender);
    const moods = this.normalize((product.moods || []).join(' '));
    const occasions = this.normalize((product.occasions || []).join(' '));
    const seasons = this.normalize((product.seasons || []).join(' '));
    const notes = this.normalize((product.notes || []).join(' '));

    if (name === q) score += 500;
    if (name.startsWith(q)) score += 280;
    if (name.includes(q)) score += 200;

    if (title.includes(q)) score += 120;
    if (fullName.includes(q)) score += 100;
    if (vendor.includes(q)) score += 70;
    if (brand.includes(q)) score += 70;
    if (designer === q) score += 220;
    else if (designer.includes(q)) score += 140;
    if (inspiredBy.includes(q)) score += 90;
    if (family.includes(q)) score += 75;
    if (gender.includes(q)) score += 60;
    if (moods.includes(q)) score += 70;
    if (occasions.includes(q)) score += 80;
    if (seasons.includes(q)) score += 60;
    if (notes.includes(q)) score += 55;

    if (tags.includes(q)) score += 45;
    if (type.includes(q)) score += 20;
    if (searchText.includes(q)) score += 90;

    const words = q.split(' ').filter(word => word.length >= 3);

    words.forEach(word => {
      if (name.split(' ').includes(word)) score += 90;
      else if (name.includes(word)) score += 55;

      if (title.includes(word)) score += 35;
      if (fullName.includes(word)) score += 30;
      if (vendor.includes(word)) score += 25;
      if (brand.includes(word)) score += 25;
      if (designer.includes(word)) score += 55;
      if (inspiredBy.includes(word)) score += 40;
      if (family.includes(word)) score += 35;
      if (gender.includes(word)) score += 30;
      if (moods.includes(word)) score += 35;
      if (occasions.includes(word)) score += 40;
      if (seasons.includes(word)) score += 30;
      if (notes.includes(word)) score += 25;
      if (tags.includes(word)) score += 15;
      if (searchText.includes(word)) score += 35;
    });

    if (product.available) score += 5;

    return score;
  },

  search(query, options = {}) {
  const q = this.expandQuery(query);
  if (q.length < 2) return [];

  const limit = options.limit || 10;
  const hideUnavailable = options.hideUnavailable === true;
  const category = this.normalize(options.category || '');

  const results = PH.state.catalog
    .filter(product => {
      if (this.isPackageProduct(product)) return false;
      if (hideUnavailable && !product.available) return false;

      if (category) {
        const productText = this.normalize([
          product.gender,
          product.family,
          product.tags,
          product.type,
          product.designer,
          product.category,
          product.searchText
        ].join(' '));

        if (!productText.includes(category)) return false;
      }

      return this.hasStrongMatch(product, q);
    })
    .map(product => ({
      ...product,
      score: this.score(product, q)
    }))
    .filter(product => product.score >= 40)
    .sort((a, b) => b.score - a.score)
    .slice(0, limit);

  console.log('[PH Search]', this.version, q, category, results);

  return results;
}
};